import React from "react";
import { Link } from "react-router-dom";

export default function Profile() {
  return (
    <>
      <div className="mainConatinerSection">
        <div className="card mb-5 mb-xl-10">
          <div className="card-body pt-9 pb-0">
            <div className="d-flex flex-wrap flex-sm-nowrap">
              <div className="me-7 mb-4">
                <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                  <img src="/assets/media/avatars/300-1.jpg" alt=" " />
                  <div className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px"></div>
                </div>
              </div>
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center mb-2">
                      <Link
                        to="#"
                        className="text-gray-900 text-hover-primary fs-2 fw-bold me-1"
                      >
                        Max Smith
                      </Link>
                      <Link to="#">
                        <i className="ki-duotone ki-verify fs-1 text-primary">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                      </Link>
                    </div>
                    <div className="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                      <Link
                        to="#"
                        className="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
                      >
                        <i className="ki-duotone ki-profile-circle fs-4 me-1">
                          <span className="path1"></span>
                          <span className="path2"></span>
                          <span className="path3"></span>
                        </i>
                        Developer
                      </Link>
                      <Link
                        to="#"
                        className="d-flex align-items-center text-gray-500 text-hover-primary me-5 mb-2"
                      >
                        <i className="ki-duotone ki-geolocation fs-4 me-1">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                        SF, Bay Area
                      </Link>
                      <Link
                        to="#"
                        className="d-flex align-items-center text-gray-500 text-hover-primary mb-2"
                      >
                        <i className="ki-duotone ki-sms fs-4">
                          <span className="path1"></span>
                          <span className="path2"></span>
                        </i>
                        max@kt.com
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-wrap flex-stack">
                  <div className="d-flex flex-column flex-grow-1 pe-8">
                    <div className="d-flex flex-wrap">
                      <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                        <div className="d-flex align-items-center">
                          <i className="ki-duotone ki-arrow-up fs-3 text-success me-2">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                          <div
                            className="fs-2 fw-bold"
                          >
                            0
                          </div>
                        </div>
                        <div className="fw-semibold fs-6 text-gray-500">
                          Earnings
                        </div>
                      </div>
                      <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                        <div className="d-flex align-items-center">
                          <i className="ki-duotone ki-arrow-down fs-3 text-danger me-2">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                          <div
                            className="fs-2 fw-bold"
                          >
                            0
                          </div>
                        </div>
                        <div className="fw-semibold fs-6 text-gray-500">
                          Projects
                        </div>
                      </div>
                      <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                        <div className="d-flex align-items-center">
                          <i className="ki-duotone ki-arrow-up fs-3 text-success me-2">
                            <span className="path1"></span>
                            <span className="path2"></span>
                          </i>
                          <div
                            className="fs-2 fw-bold"
                          >
                            0
                          </div>
                        </div>
                        <div className="fw-semibold fs-6 text-gray-500">
                          Success Rate
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex align-items-center w-200px w-sm-300px flex-column mt-3">
                    <div className="d-flex justify-content-between w-100 mt-auto mb-2">
                      <span className="fw-semibold fs-6 text-gray-500">
                        Profile Compleation
                      </span>
                      <span className="fw-bold fs-6">50%</span>
                    </div>
                    <div className="h-5px mx-3 w-100 bg-light mb-3">
                      <div
                        className="bg-success rounded h-5px"
                        role="progressbar"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                  to="account/overview.html"
                >
                  Overview
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                  to="account/settings.html"
                >
                  Settings
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                  to="account/security.html"
                >
                  Security
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                  to="account/activity.html"
                >
                  Activity
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                  to="account/billing.html"
                >
                  Billing
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                  to="account/statements.html"
                >
                  Statements
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                  to="account/referrals.html"
                >
                  Referrals
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  className="nav-link text-active-primary ms-0 me-10 py-5 active"
                  to="account/api-keys.html"
                >
                  API Keys
                </Link>
              </li>
              <li className="nav-item mt-2">
                <Link
                  to="account/logs.html"
                  className="nav-link text-active-primary ms-0 me-10 py-5"
                >
                  Logs
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
